import { render, staticRenderFns } from "./SponsorAdd.vue?vue&type=template&id=ee555898&scoped=true&"
import script from "./SponsorAdd.vue?vue&type=script&lang=js&"
export * from "./SponsorAdd.vue?vue&type=script&lang=js&"
import style0 from "./SponsorAdd.vue?vue&type=style&index=0&id=ee555898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee555898",
  null
  
)

export default component.exports